import instance from '../../api';
import { message } from 'antd';
import { ErrorNotification } from '../../../Utils/data';
import { TableParams } from '../../../Utils/TableTypes';

export const truckInfo = {
  async getActionFileTypes() {
    const { data }: any = await instance(`admins/action-file-types`);
    return Array.isArray(data?.data) ? data.data : Array.isArray(data) ? data : [];
  },

  async createActionFileType(body: {
    type: string;
    title: string;
    isCalendarExist?: boolean;
  }) {
    const key = 'create-action-file-type';
    message.loading({ content: 'Loading...', key });
    try {
      const { data }: { data: any } = await instance(`admins/action-file-types`, {
        method: 'POST',
        data: body,
      }).then((u) => {
        setTimeout(() => {
          message.success({ content: 'Loaded!', key, duration: 2 });
        }, 600);
        return u;
      });
      return data;
    } catch (error: any) {
      if (error.response && error.response.status) {
        ErrorNotification({
          status: error.response.status,
          message: error.response.data.error.message,
        });
      }
      throw error;
    }
  },

  async updateActionFileType(
    id: string | number,
    body: {
      type: string;
      title: string;
      isCalendarExist?: boolean;
    },
  ) {
    const key = `update-action-file-type-${id}`;
    message.loading({ content: 'Loading...', key });
    try {
      const { data }: { data: any } = await instance(`admins/action-file-types/${id}`, {
        method: 'PATCH',
        data: body,
      }).then((u) => {
        setTimeout(() => {
          message.success({ content: 'Loaded!', key, duration: 2 });
        }, 600);
        return u;
      });
      return data;
    } catch (error: any) {
      if (error.response && error.response.status) {
        ErrorNotification({
          status: error.response.status,
          message: error.response.data.error.message,
        });
      }
      throw error;
    }
  },

  async deleteActionFileType(id: string | number) {
    const key = `delete-action-file-type-${id}`;
    message.loading({ content: 'Loading...', key });
    try {
      const { data }: { data: any } = await instance(`admins/action-file-types/${id}`, {
        method: 'DELETE',
      }).then((u) => {
        setTimeout(() => {
          message.success({ content: 'Loaded!', key, duration: 2 });
        }, 600);
        return u;
      });
      return data;
    } catch (error: any) {
      if (error.response && error.response.status) {
        ErrorNotification({
          status: error.response.status,
          message: error.response.data.error.message,
        });
      }
      throw error;
    }
  },

  async read(driverId: number) {
    const { data }: any = await instance(`users/truck-info/${driverId}`);
    return {
      data: data.data,
      count: data.count,
    };
  },

  async getOneTruckInfo(truckInfoId: number | undefined) {
    const { data }: { data: object } = await instance(`users/truck-info/${truckInfoId}`);
    return data;
  },

  async getDocuments(
    id: string | undefined,
    userId: undefined | number | string,
    companyId: number | string,
    type: string | number,
    tableParams: TableParams,
  ) {
    if (userId === undefined) userId = '';
    if (companyId === undefined) companyId = '';
    const safePage = tableParams?.pagination?.current ?? 1;
    let url = id
      ? `documents/list?page=${safePage}&perPage=10&userId=${id}`
      : `documents/list?page=${safePage}&perPage=10&userId=${userId}&companyId=${companyId}&type=${type}`;
    try {
      const { data }: any = await instance(url);
      return {
        data: data.data,
        count: data.count,
      };
    } catch (error: any) {
      if (error.response && error.response.status) {
        ErrorNotification({
          status: error.response.status,
          message: error.response.data.error.message,
        });
      }
    }
  },

  async commandsPost(body: any) {
    const key = 'updatable';
    message.loading({ content: 'Loading...', key });
    try {
      const { data }: { data: any } = await instance(`commands/v2/message`, {
        method: 'POST',
        data: body,
      }).then((u) => {
        setTimeout(() => {
          message.success({ content: 'Loaded!', key, duration: 2 });
        }, 1000);
        return u;
      });
      return data;
    } catch (error: any) {
      if (error.response && error.response.status) {
        ErrorNotification({
          status: error.response.status,
          message: error.response.data.error.message,
        });
      }
    }
  },
};
